module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cb-header__wrap cb-header__wrap--nav",
    attrs: {
      "role": "navigation"
    },
    on: {
      "click": _vm.back
    }
  }, [_c('div', {
    directives: [{
      name: "cb-link",
      rawName: "v-cb-link",
      value: ('color'),
      expression: "'color'"
    }],
    staticClass: "cb-header__title"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('div', {
    key: _vm.header,
    staticClass: "cb-transition__fade--short"
  }, [_c('i', {
    staticClass: "icon-angle-left cb-header__icon"
  }), _c('span', {
    staticClass: "cb-header__text"
  }, [_vm._v(_vm._s(_vm.header))])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cfc7cda0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/collections/headers/Type2.vue
// module id = 136
// module chunks = 83 84 85 86